import { AlpineTesting } from '../sections/AlpineTesting';
import { Contact } from '../sections/Contact';
import { Hero } from '../sections/Hero';
import { Manufacturing } from '../sections/Manufacturing';
import { Modes } from '../sections/Modes';
import { Phrase } from '../sections/Phrase';
import { Quality } from '../sections/Quality';

export function HomePage() {
  return (
    <main id="main-content" className="main-wrapper">
      <Hero />
      <Modes />
      <Phrase />
      <Quality />
      <Manufacturing />
      <AlpineTesting />
      <Contact />
    </main>
  );
}
